import { Component , Vue , Prop, Mixins } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { SECTION_TYPES } from '@/content/values/sections';
import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import { HOMEWORKS_EVENTS, SHOW_RESPONSE_TABS } from '@/homework/values/homeworks.values';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';

@Component({})
export class CourseHomeworkSplitObjectMixin extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly section: Section;

  /* Data */
  public problem: Section = null;
  public solution: Section = null;
  public menu: IEdTabsMenu[] = [];
  public menuProblemSplit: IEdTabsMenu[];
  public menuResponseSplit: IEdTabsMenu[];
  public tabSelected: string = '';
  public firstHorizontal: boolean = false;
  public contentsId = {
    problem: 'ProblemTab',
    response: 'ResponseTab',
    solution: 'SolutionTab',
    splitHorizontal: 'SplitHorizontal',
    splitVertical: 'SplitVertical',
  };

  /* Computed */
  get oneviewSelected() {
    switch(this.tabSelected) {
      case this.contentsId.problem:
      case this.contentsId.response:
      case this.contentsId.solution:
        return true;
      break;
      default:
        return false;
      break;
    }
  }

  get problemUrl(): string {
    return this.problem.assetsInfo[0].url;
  }

  get isShowResponseBoard() : boolean {
    return SHOW_RESPONSE_TABS.includes(this.tabSelected);
  }

  get viewerProblem() {
    let viewer:any = SECTION_TYPES.LESSON_PDF.viewer;
    if( this.problem.sectionMaterial ) {
      viewer = this.setCourseMaterialViewer(this.problem.sectionMaterial);
    }
    return viewer;
  }

  get viewerSolution() {
    let viewer:any = SECTION_TYPES.LESSON_PDF.viewer;
    if( this.solution.sectionMaterial ) {
      viewer = this.setCourseMaterialViewer(this.solution.sectionMaterial);
    }
    return viewer;
  }

  get problemMaterial(): any {    
    if(this.problem.sectionMaterial && this.$store.state.CourseStore.isPresentationStudentMode){
      let sectionMaterial = this.problem.sectionMaterial;
      sectionMaterial.data = {...sectionMaterial.materialAssetInfo};      
      return sectionMaterial;
    }
    return this.problem.sectionMaterial;
  }

  

  /* Methods */
  setFiles() {
    this.section.sections.forEach((s) => {
      switch(s.type) {
        case SECTION_TYPES.SPLIT_QUESTION_PDF.code:
          this.problem = s;
        break;
        case SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code:
          this.problem = new Section({
            name: s.name,
            type: SECTION_TYPES.LESSON_PDF.code,
            text: s.sectionMaterial.materialAssetInfo.hash,
            sectionMaterial: s.sectionMaterial,
            assetsInfo: [{
              url: s.sectionMaterial.splicedUrl
            }]
          });
        break;
        case SECTION_TYPES.SPLIT_SOLUTION_PDF.code:
            this.solution = s;
          break;
        case SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code:
          this.solution = new Section({
            ...s,
            type: SECTION_TYPES.LESSON_PDF.code,
            text: s.sectionMaterial.materialAssetInfo.hash,
            assetsInfo: [{
              url: s.sectionMaterial.splicedUrl
            }]
          });
        break;
      }
    });
  }

  setMenuSplit(isTeacher : boolean) {
    this.menuProblemSplit = [{
      name: String(this.$i18n.t('courses.writeObject.problemTab')),
      contentId: this.contentsId.problem,
      active: true,
      visible: true
    }];

    if(isTeacher && this.solution){
      this.menuProblemSplit.push({
        name: String(this.$i18n.t('courses.writeObject.solutionTab')),
        contentId: this.contentsId.solution,
        active: false,
        visible: true
      });
    }

    this.menuResponseSplit = [{
      name: String(this.$i18n.t('courses.writeObject.responseTab')),
      contentId: this.contentsId.response,
      active: true,
      visible: true
    }];
  }

  settingTab(tabParams: any) {
    if(this.tabSelected !== tabParams.contentId) {
      let problem: any = document.getElementById('Problem');
      let response: any = document.getElementById('Response');
      let solution: any = document.getElementById('Solution');
      let menuVisible: boolean = false;
      if(tabParams.contentId == this.contentsId.splitVertical) {
        let problemVertical = document.getElementById('ProblemTabVertical');
        if(response) {
          let responseVertical = document.getElementById('ResponseTabVertical');
          responseVertical?.appendChild(response);
        }
        if(solution) {
          let solutionVertical = document.getElementById('SolutionTabVertical');
          solutionVertical?.appendChild(solution);
        }
        problemVertical?.appendChild(problem);
        menuVisible = false;
      } else if(tabParams.contentId == this.contentsId.splitHorizontal) {
        let problemHorizontal = document.getElementById('ProblemTabHorizontal');
        if(response) {
          let responseHorizontal = document.getElementById('ResponseTabHorizontal');
          responseHorizontal?.appendChild(response);
        }
        if(solution) {
          let solutionHorizontal = document.getElementById('SolutionTabHorizontal');
          solutionHorizontal?.appendChild(solution);
        }
        problemHorizontal?.appendChild(problem);
        menuVisible = false;
      } else {
        let problemContainer = document.getElementById('ProblemContainer');
        problemContainer?.appendChild(problem);
        if(response) {
          let responseContainer = document.getElementById('ResponseContainer');
          responseContainer?.appendChild(response);
        }
        if(solution) {
          let solutionContainer = document.getElementById('SolutionContainer');
          solutionContainer?.appendChild(solution);
        }
        menuVisible = true;
        
        this.menu.forEach(m => {
          m.active = m.contentId == tabParams.contentId;
        });
      }
      tabParams.el.setTab(tabParams.contentId);
      this.setMainMenuVisible(menuVisible);
      this.tabSelected = tabParams.contentId;
      this.$edEventBus.$emit(HOMEWORKS_EVENTS.CHANGE_SPLIT_TAB);
    }
  }

  setMainMenuVisible(state: boolean) {
    this.menu = this.menu.map(m => {
      if(m.contentId == this.contentsId.problem || m.contentId == this.contentsId.response  || m.contentId == this.contentsId.solution) {
        return { ...m, visible: state };
      } else {
        return m;
      }
    })
  }

  
}